import React, { useContext, useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { getAutoBiography } from '../api/UserRequest'
import AutoBiography from '../components/autoBiographyThemes/autoBiography/AutoBiography'
import { Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import logo from '../assests/zeeqr-black.svg'
import { CardContext } from '../components/store/CardContext'

function AutoBiographyPage() {
    const params = useParams()
    const [card, setCard] = useState('')
    const [pre, setPre] = useState(true)
    const [, setCardData] = useContext(CardContext)
    // const { i18n } = useTranslation()


    useEffect(() => {

        const getDetails = async () => {
            try {
                // console.log(params.id, '11111111111');
                // console.log(liveLocation,'qwertyuio');
                const path = {
                    url: window.location.href
                }
                const { data } = await getAutoBiography(params.id, path)
                // console.log(data, 'dataaaaaaaaaaa');
                // console.log(data.footerText, 'dataaaaaaaaaaa');
                if (data.success) {

                    if (data?.biographyData?.loader) {

                        setTimeout(() => {
                            // console.log(preview, 'dataaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa');
                            // setPre(preview)
                            setPre(false)
                        }, 2000);
                    } else {
                        setPre(false)
                    }
                    // data.card.footerText = data?.footerText 
                    // data.card.footerText = true
                    // console.log(data, 'dataaaaaaaaaaa');
                    setCard(data.biographyData)
                    // cardDetails(data.card)
                    setCardData(data.biographyData)
                    // i18n.changeLanguage(data?.biographyData?.language)
                    document.title = data.biographyData.personalInfo.name
                    document.getElementsByTagName("META")[2].content = data.biographyData.personalInfo.designation


                    let link = document.querySelector("link[rel~='icon']");
                    if (!link) {
                        link = document.createElement("link");
                        link.rel = "icon";
                        document.getElementsByTagName("head")[0].appendChild(link);
                    }
                    link.href = data.biographyData.faviconImage

                    let linkAppple = document.querySelector("link[rel~='apple-touch-icon']");
                    if (!linkAppple) {
                        linkAppple = document.createElement("link");
                        linkAppple.rel = "apple-touch-icon";
                        document.getElementsByTagName("head")[0].appendChild(linkAppple);
                    }
                    linkAppple.href = data.biographyData.personalInfo.profileImg ? data.biographyData.personalInfo.profileImg : 'https://zeeqr-files.s3.ap-south-1.amazonaws.com/assets/defaultProfile.jpg'
                    // console.log(data.biographyData.personalInfo.profileImg,'data.biographyData.personalInfo.profileImg');
                    // const liveLocation = await axios.get('https://ipapi.co/json')
                    // await addLocation(data.biographyData._id, liveLocation.data)

                }
            } catch (error) {
                setPre(false)
                setCard('')
                console.log(error);
            }
        }

        // const cardDetails = (data) => {
        //     const cardDatas = {
        //         cardID: data._id,
        //         backgroundImage: data?.backgroundImage,
        //         bgImg: data?.bgImg,
        //         bgImgType: data?.bgImgType,
        //         bgImgRepeat: data?.bgImgRepeat,
        //         profileImage: data?.profileImage,
        //         companyLogo: data?.companyLogo,
        //         personalDetails: {
        //             name: data?.name,
        //             companyDesignation: data?.companyDesignation,
        //             companyName: data?.companyName,
        //             about: data?.about,
        //             aboutHeadline: data?.aboutHeadline,
        //             phone: data?.phone,
        //             secondaryPhone: data?.secondaryPhone,
        //             email: data?.email,
        //             secondaryEmail: data?.secondaryEmail,
        //             nameSize: data?.nameSize,
        //             designationSize: data?.designationSize

        //         },
        //         socialMediaDetails: {
        //             facebook: data?.facebook,
        //             instagram: data?.instagram,
        //             whatsappNumber: data?.whatsappNumber,
        //             linkedin: data?.linkedin,
        //             twitter: data?.twitter,
        //             youtube: data?.youtube,
        //             skype: data?.skype,
        //             snapchat: data?.snapchat,
        //             tiktok: data?.tiktok,
        //             companyProfile: data?.companyProfile,
        //         },
        //         socialMedias: data?.socialMedias,
        //         websiteDetails: {
        //             websiteName: data?.websiteName,
        //             websiteUrl: data?.websiteUrl,
        //         },
        //         website: data?.website,
        //         review: data?.reviews,
        //         contactDetails: {
        //             address: data?.address,
        //             state: data?.state,
        //             country: data?.country,
        //             locationUrl: data?.locationUrl,
        //         },
        //         websiteImage: data?.websiteImage,
        //         fileName: {
        //             fileName1: data?.files?.file1?.fileName,
        //             fileName2: data?.files?.file2?.fileName,
        //             fileName3: data?.files?.file3?.fileName,
        //             fileName4: data?.files?.file4?.fileName,

        //         },
        //         files: {
        //             file1: data?.files?.file1?.fileUrl,
        //             file2: data?.files?.file2?.fileUrl,
        //             file3: data?.files?.file3?.fileUrl,
        //             file4: data?.files?.file4?.fileUrl,
        //         },
        //         highlightPhotos1: data?.highlightPhotos[0].highlightPhotos1,
        //         highlightPhotos2: data?.highlightPhotos[0].highlightPhotos2,
        //         highlightPhotos3: data?.highlightPhotos[0].highlightPhotos3,
        //         highlightPhotos4: data?.highlightPhotos[0].highlightPhotos4,
        //         highlightPhotos5: data?.highlightPhotos[0].highlightPhotos5,
        //         highlightPhotos6: data?.highlightPhotos[0].highlightPhotos6,
        //         highlightPhotos7: data?.highlightPhotos[0].highlightPhotos7,
        //         highlightPhotos8: data?.highlightPhotos[0].highlightPhotos8,
        //         vCard: data?.vCard,
        //         QRCode: data?.QRCode,
        //         checkProfile: data?.checkProfile,
        //         checkPfCard: data?.checkPfCard,
        //         checkLogo: data?.checkLogo,
        //         checkHighlight: data?.checkHighlight,
        //         SMediaPostion: data?.SMediaPostion,
        //         Highlightcolor: data?.colorCode,
        //         Textcolor: data?.textColor,
        //         Iconcolor: data?.iconBgColor,
        //         BgColor: data?.bgColor,
        //         BtIColor: data?.btIconColor,
        //         footerText: data?.footerText,
        //     }


        //     setCardData(cardDatas)
        // }

        getDetails()
    }, [params.id])



    return (
        <div>
            {pre ?
                <div className='w-full h-screen flex items-center justify-center'>
                    {card?.loader ?
                        <img src={card.loader} alt='' />
                        :
                        <Spin
                            indicator={
                                <LoadingOutlined
                                    style={{
                                        fontSize: 60,
                                        color: 'black'
                                    }}
                                    spin
                                />
                            }
                        />
                    }
                </div>
                :
                (
                    card ?
                        (
                            <AutoBiography />
                        )

                        :
                        <div className='w-full h-screen flex flex-col items-center justify-center'>
                            <img src={logo} alt="" />
                            <h1 className='font-bold mt-2'>This card is not valid/card has expired!</h1>
                            <p className='mt-1'>Please contact the admin</p>
                            <Link to={'https://wa.me/+971505363704?text=Hi%2C'} target="blank" >
                                <button className='p-2 mt-3 border-2 rounded-xl border-black'>Get In Touch</button>
                            </Link>

                        </div>

                )
            }

            {/* <AutoBiography /> */}
        </div>
    )
}

export default AutoBiographyPage